import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-options-product',
  templateUrl: './options-product.component.html',
  styleUrls: ['./options-product.component.scss'],
})
export class OptionsProductComponent implements OnInit, OnDestroy {
  @Input() set savedForm(value: any[]){
    if(value){
      if(value.length){
        setTimeout(async () => {
          await this.getForm();
          this.savedOptions = value;
        })
      }else{
        this.savedOptions = [];
        this.fieldForms = undefined;
      }
    }
  };
  @Input() domainId = undefined;
  @Input() uri = undefined;
  @Input() route = undefined;
  @Output() segment = new EventEmitter();
  @Output() emitFormValue = new EventEmitter();
  public fieldForms;
  public savedOptions = [];
  public savedFormLoaded = [];
  public setId = true;
  public loading = false;
  private _subscription: Subscription = new Subscription();

  constructor(
    private formSv: FormServices,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private translateSv: TranslateService,
    public loginSv: LoginService
  ) { }

  async ngOnInit() {
    this._subscription.add(
      this.formSv.copySrc
        .subscribe((data: boolean) => {
          this.setId = data;
        })
    );
    
    this.getForm();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  async getForm(push?){
    try{
      this.loading = true;
      if(!this.fieldForms){
        const res: any[] = await this.formSv.getForm(this.uri, this.domainId);
        this.fieldForms = res;
        if(!res.length){
          this.segment.emit(this.route);
        }
      }
      if(push) this.savedOptions.push(1);
      this.loading = false;
      return true;
    }catch(err){
      await this.uiSv.loading.dismiss();
      console.error(err);
    }
  }

  async sendInfo(ev: FormData, index){
    try{
      if(ev){
        const obj: any = {};
        ev.forEach((item, key) => {
          if(item === 'null'){
            item = '';
          }
          if(key === 'products') key = 'imageOptions'
          obj[key] = item;
        })
  
        const id = this.savedOptions[index]?.id;
        if(id && this.setId){
          obj.id = id;
        }
        this.emitFormValue.emit(obj);
      }
    }catch(err){
      console.error(err);
    }
  }

  async deleteForm(index){
    try{
      const optionId = this.savedOptions[index]?.id;
      if(optionId){
        const msg = this.translateSv.instant('ELIMINANDO_OPCION');
        await this.uiSv.showLoading(msg);
        const body = { id: optionId }
        await this.httpSv.itemAction(body, 'product', 'destroy');
        await this.uiSv.loading?.dismiss();
      }
      this.savedOptions.splice(index, 1);
    }catch(err){
      await this.uiSv.loading?.dismiss();
      console.error(err);
    }
  }
}
